const frIntegerFormatter = new Intl.NumberFormat('fr-FR', {
  maximumFractionDigits: 0,
});

export function formatHaFr(value: number | null | undefined): string {
  if (value === null || value === undefined || Number.isNaN(value)) {
    return '—';
  }
  return frIntegerFormatter.format(Math.round(value));
}

export function formatCountFr(value: number | null | undefined): string {
  if (value === null || value === undefined || Number.isNaN(value)) {
    return '—';
  }
  return frIntegerFormatter.format(Math.round(value));
}

/** French grouped number + unit (e.g. `39\u202f170 ha`). */
export function formatHaUnitFr(value: number | null | undefined): string {
  const formatted = formatHaFr(value);
  return formatted === '—' ? formatted : `${formatted}\u00a0ha`;
}

export function formatTonnesUnitFr(value: number | null | undefined): string {
  const formatted = formatCountFr(value);
  return formatted === '—' ? formatted : `${formatted}\u00a0t`;
}

export function formatPercentUnitFr(value: number | null | undefined): string {
  const formatted = formatCountFr(value);
  return formatted === '—' ? formatted : `${formatted}\u00a0%`;
}
